<template>
  <div class="indexBox">
    <div class="guide" v-if="show === 1">
      <div class="one" v-intro="'点击这里修改密码'"></div>
      <div class="two" v-intro="'点击这里修改密码'"></div>
      <div class="three" v-intro="'这里是基本设置'"></div>
      <div class="four" v-intro="'这里是栏目设置'"></div>
      <div class="five" v-intro="'这里是内容管理'"></div>
      <div class="six" v-intro="'这里是帮助文档和客户端下载'"></div>
    </div>
    <el-container class="index-con">
      <el-aside :class="showclass">
        <p
          style="
            color: #ffffff;
            line-height: 60px;
            text-align: center;
            font-size: 20px;
            font-weight: 400;
          "
        >
          拇指哥站群管理平台
        </p>
        <div class="logo">
          <img
            :src="settings.apiBaseImg + head"
            alt="logo"
            @click="goHome()"
            :class="logo"
            v-if="head != null"
          />
          <img
            src="../assets/images/head.png"
            alt="logo"
            @click="goHome()"
            :class="logo"
            v-if="head == null"
          />
        </div>
        <!-- <el-menu default-active="2" :default-openeds="openeds" router class="el-menu-vertical-demo" @open="handleOpen"
				 router background-color="#202436" text-color="#fff" :unique-opened="true" active-text-color="#ffd04b" :collapse="isCollapse"
				 style="height:calc(100vh - 210px);">
					<el-menu-item collapse="true" v-for="(item1,index) in menuList" v-if="!item1.childColumn" :index="item1.routeName"
					 :key="index" @click="goDetails(item1)">
						<template slot="title">
							<i class="iconfont" :class="[item1.icont != ''?item1.icont:'']"></i>
							<span slot="title">{{item1.columname}}</span>
						</template>
					</el-menu-item>
					<el-submenu v-for="(item1,index) in menuList" v-if="item1.childColumn" :key="index" :index="String(index)">
						<el-menu-item v-if="!item2.childColumn" v-for="item2 in item1.childColumn" :key="item2.index" :index="item2.routeName"
						 @click.native="handleSelect(item2,index)"  @click="goDetails(item2)">
								{{item2.columname}}
						</el-menu-item>
						<template slot="title" v-if="item1.childColumn">
							<i class="iconfont" :class="[item1.icont != ''?item1.icont:'']"></i>
							<span slot="title">{{item1.columname}}</span>
						</template>
						<el-submenu v-for="(item2,index) in item1.childColumn" v-if="item2.childColumn!= null" :key="index" :index="item2.routeName">
							<template slot="title" v-if="item2.childColumn">
								<span slot="title">{{item2.columname}}</span>
							</template>
							<el-menu-item-group >
								<el-menu-item  @click="goDetails(item3)"  @click.native="handleSelect(item3,index)":index="item3.routeName" v-for="item3 in item2.childColumn" :key="item3.index">{{item3.columname}}</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
					</el-submenu>
				</el-menu> -->
        <el-menu
          default-active="1"
          :default-openeds="openeds"
          router
          class="el-menu-vertical-demo"
          @open="handleOpen"
          router
          background-color="#202436"
          text-color="#fff"
          :unique-opened="true"
          active-text-color="#ffd04b"
          :collapse="isCollapse"
          style="height: calc(100vh - 210px)"
        >
          <NavMenu
            v-for="item in menuList"
            :key="item.id"
            :menu="item"
          ></NavMenu>
        </el-menu>
      </el-aside>
      <el-container class="main-con">
        <el-header :class="headerShow" style="padding: 0 !important">
          <el-menu
            class="el-menu-demo"
            router
            mode="horizontal"
            background-color="#202436"
            text-color="#fff"
            active-text-color="#fff"
          >
            <el-menu-item @click.native="toggle(isCollapse)">
              <template slot="title">
                <img class="showimg" :src="isCollapse ? imgsq : imgshow" />
                <!--头像，-->
              </template>
            </el-menu-item>
            <el-menu-item index="" style="margin-left: 20px">
              <el-input
                v-model="input"
                placeholder="请输入关键字"
                class="input"
                prefix-icon="el-icon-search"
              >
              </el-input>
            </el-menu-item>
            <el-submenu index="2" style="float: right">
              <template slot="title">
                <img
                  :src="settings.apiBaseImg + head"
                  alt="logo"
                  @click="goHome()"
                  class="head"
                  v-if="head != null"
                />
                <img
                  src="../assets/images/head.png"
                  alt="logo"
                  @click="goHome()"
                  class="head"
                  v-if="head == null"
                />
              </template>
              <el-menu-item index="" @click="exit()">退出登录</el-menu-item>
              <el-menu-item index="/home/password"
                ><div>修改密码</div></el-menu-item
              >
              <!-- <el-menu-item index="/home/updateHead">修改头像</el-menu-item> -->
            </el-submenu>
            <el-menu-item
              style="float: right; margin-right: 60px"
              @click.native="goFile()"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="查看教学文档"
                placement="top"
              >
                <i
                  class="iconfont iconlianjie"
                  style="font-size: 26px; color: #ffffff"
                ></i>
              </el-tooltip>
            </el-menu-item>
            <el-menu-item style="float: right" @click.native="goDown">
              <el-tooltip
                class="item"
                effect="dark"
                content="下载客户端"
                placement="top"
              >
                <i
                  class="iconfont iconxiazai"
                  style="font-size: 26px; color: #ffffff"
                ></i>
              </el-tooltip>
            </el-menu-item>
            <el-menu-item style="float: right" @click.native="goVideo">
              <el-tooltip
                class="item"
                effect="dark"
                content="查看视频教学"
                placement="top"
              >
                <i
                  class="iconfont iconshipin"
                  style="font-size: 26px; color: #ffffff"
                ></i>
              </el-tooltip>
            </el-menu-item>
          </el-menu>
        </el-header>
        <el-main :class="mains">
          <div class="tab">
            <el-tag
              :key="tag.columname"
              size="small"
              v-for="(tag, index) in tabList"
              :closable="tag.columname !== '首页'"
              :disable-transitions="false"
              @close="handleClose(tag, index)"
              @click="changeMenu(tag)"
              type="info"
              :effect="$route.fullPath === tag.routeName ? 'dark' : 'plain'"
            >
              {{ tag.columname }}
            </el-tag>
          </div>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <!-- 这里边是指引 -->
  </div>
</template>
<script>
import NavMenu from './menu.vue'
import {
  mapMutations
} from 'vuex'
import bus from '../assets/js/bus.js'
export default {
  components: {
    NavMenu
  },
  name: 'index',
  inject: ['reload'],
  data () {
    return {
      status: '',
      show: '',
      showclass: 'asideshow',
      logo: 'logoImg',
      showtype: false,
      mains: 'index-main',
      title: '',
      headerShow: 'index-header',
      isCollapse: false,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      account: '',
      openeds: ['0'],
      // 导航搜索
      input: '',
      icon: '',
      menuList: [{
        id: 1,
        columname: '系统首页',
        icont: 'iconindex-copy',
        routeName: '/home/index'
      },
      {
        id: 6,
        title: '内容管理',
        columname: '内容管理',
        routeName: '/home/content',
        icont: 'iconneirongguanli'
      },
      {
        id: 2,
        title: '广告管理',
        columname: '广告管理',
        routeName: '/home/advertManage',
        icont: 'iconguanggaoguanli'
      },
      {
        id: 54,
        title: '应用中心',
        columname: '应用中心',
        routeName: '/home/bullet',
        icont: 'iconyingyong-copy'
      },
      {
        id: 110,
        columname: '界面管理',
        icont: 'iconjiemianguanli',
        routeName: '/home/phone',
        columnMenuList: [{
          id: 56,
          title: '首页简介',
          columname: '首页简介',
          routeName: '/home/introduction'
        }

        ]
      },
      {
        id: 3,
        columname: '运营管理',
        icont: 'iconyunying',
        columnMenuList: [{
          id: 31,
          title: '运营管理',
          columname: '运营管理',
          routeName: '/home/operate'
        },
        {
          id: 32,
          title: '友情链接',
          columname: '友情链接',
          routeName: '/home/link'
        }
        ]
      },
      {
        id: 4,
        columname: '手机设置',
        icont: 'iconshouji',
        routeName: '/home/phone',
        columnMenuList: [{
          id: 41,
          title: '基础设置',
          columname: '基础设置',
          routeName: '/home/phoneBanner'
        }, {
          id: 42,
          title: 'Banner设置',
          columname: 'Banner',
          routeName: '/home/phone'
        }
        ]
      },
      {
        id: 5,
        columname: '设置',
        icont: 'iconshezhi',
        routeName: '/home/system',
        columnMenuList: [{
          id: 51,
          title: '基本设置',
          columname: '基本设置',
          routeName: '/home/basicSystem'
        }, {
          id: 52,
          title: 'Banner设置',
          columname: 'Banner',
          routeName: '/home/systemBanner'
        },
        {
          id: 53,
          title: '栏目设置',
          columname: '栏目设置',
          routeName: '/home/column'
        },
        {
          id: 54,
          title: '表单管理',
          columname: '表单管理',
          routeName: '/home/formManage'
        },
        // {
        //   id: 56,
        //   title: '专题管理',
        //   columname: '专题管理',
        //   routeName: '/home/special'
        // }
        ]
      }

      ],
      fullscreen: false,
      tabList: [],
      head: ''
    }
  },
  mounted () {
    bus.$on('getHead', res => {
      this.getHead()
    })
  },
  computed: {
  },
  methods: {
    ...mapMutations({
      close: 'closeTab'
    }),
    // 获取素材库的设置
    async getstatus () {
      // const res = await this.$http({
      //   method: 'post',
      //   url: '/api/v1/type'
      // })
      // console.log('状态接口', res)
      // if (res.data.status === 200) {
      //   localStorage.setItem('status', res.data.data)
      //   if (res.data.data === 1) {
      //     this.menuList[this.menuList.length - 1].columnMenuList.push({
      //       id: 55,
      //       title: '素材库设置',
      //       columname: '素材库设置',
      //       routeName: '/home/library'
      //     })
      //   }
      // }
    },
    async gettime () {
      const res = await this.$http({
        method: 'post',
        url: '/api/v1/times'
      })
      if (res.status === 200) {
        this.show = res.data.data
        console.log('这个是什么', this.show)
        if (this.show === 1) {
          let _this = this
          this.$nextTick(() => {
            var introJS = require('intro.js')
            introJS().setOptions({
              prevLabel: '上一步',
              nextLabel: '下一步',
              skipLabel: '跳过',
              doneLabel: '完成',
              stageBackground: '#fff'
            }).oncomplete(() => {
              _this.gettime()
              // 点击结束按钮后执行的事件
            }).onexit(() => {
              _this.gettime()
              // 点击跳过按钮后执行的事件
            }).start() // 退出引导调用 exit() 即可
          })
        }
      }
    },
    handleClose (tag, index) {
      let length = this.tabList.length - 1
      // vuex调方法的另一种写法
      this.close(tag)
      // 如果关闭的标签不是当前路由的话，就不跳转
      if (tag.name !== this.$route.name) {
        return
      }
      // 关闭的标签是最右边的话，往左边跳转一个
      if (index === length) {
        this.$router.push({
          name: this.tags[index - 1].name
        })
      } else {
        // 否则往右边跳转
        this.$router.push({
          name: this.tags[index].name
        })
      }
    },
    // 选择标签跳转路由
    changeMenu (item) {
      this.effect = this.$route.fullPath.substring(0, this.$route.fullPath.lastIndexOf('?'))
      this.$router.push({
        path: item.routeName,
        query: {
          id: item.id
        }
      })
    },
    handleOpen (key, keyPath) { },
    handleSelect (item, index) {
      this.$store.commit('selectMenu', item)
    },
    // 菜单切换
    toggle (showtype) {
      this.isCollapse = !showtype
      if (this.isCollapse == true) {
        this.showclass = 'aside'
        this.logo = 'logoImgX'
        this.headerShow = 'hideHeader'
        this.mains = 'hideMain'
      } else {
        this.showclass = 'asideshow'
        this.logo = 'logoImg'
        this.headerShow = 'index-header'
        this.mains = 'index-main'
      }
    },
    goHome () {
      this.$router.push({
        path: '/home/index'
      })
    },
    // 时间
    getTimes () {
      this.account = window.localStorage.getItem('account')
    },
    // 退出
    exit () {
      var _this = this
      this.$confirm('确认退出吗?', '提示', {
        // type: 'warning'
      }).then(() => {
        _this.$router.push('/')
        window.localStorage.clear()
      }).catch(() => {

      })
    },
    // 回到首页
    Home () {
      this.$router.push({
        path: '/home'
      })
    },
    // 个人信息
    person () {
      this.$router.push({
        path: '/home/person'
      })
    },
    // 获取菜单
    getMenu () {
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v2/column/menu'
      }).then((res) => {
        if (res.data.status == 200) {
          // var data = res.data.data
          // data.id = "d1111"
          // obj.menuList.push(res.data.data)
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    goDetails (item) {
      this.$route.push({
        path: item.routeName,
        query: {
          id: item.id,
          pid: item.pid
        }
      })
    },
    // 获取头像
    getHead () {
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/user/info/avatar'
      }).then((res) => {
        if (res.status == 200) {
          this.head = res.data.data.avatar
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    goFile () {
      window.open('https://muzhige.com.cn/#/help?menuId=4&modular=4', '_target')
    },
    goVideo () {
      window.open('https://muzhige.com.cn/#/video?menuId=3&modular=3', '_target')
    },
    goDown () {
      window.open('https://siteapi.renhegroup.net/site-api/profile/upload/download/muzhige.zip', '_target')
    }
  },
  created () {
    this.gettime()
    this.getTimes()
    this.tabList = this.$store.state.tabsList
    this.getstatus()
    // 获取菜单
    this.getMenu()
    this.getHead()
    var name = this.$route.fullPath.substring(0, this.$route.fullPath.lastIndexOf('?') + 1)
  },
  beforeUpdate () { },
  // 挂载前状态(里面是操作)
  beforeMount () {

  }

}
</script>
<style scoped="scoped">
.guide {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background: url("../assets/img/fmt.png") no-repeat;
  background-size: 100% 100%;
  z-index: 10000;
  /* background: red; */
}
.one {
  width: 6%;
  height: 5vh;
  position: absolute;
  right: 0;
  top: 0;
}
.two {
  width: 9%;
  height: 3.6vh;
  position: absolute;
  right: 1%;
  top: 11%;
}
.three {
  width: 12%;
  height: 5.1vh;
  position: absolute;
  left: 0%;
  top: 64%;
}
.four {
  width: 12%;
  height: 5.1vh;
  position: absolute;
  left: 0%;
  top: 75%;
}
.five {
  width: 12%;
  height: 5.1vh;
  position: absolute;
  left: 0%;
  top: 25%;
}
.six {
  width: 10%;
  height: 5.1vh;
  position: absolute;
  left: 82%;
  top: 0%;
}
a {
  text-decoration: none;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 24px;
}

html,
body,
#app,
.indexBox,
.el-container {
  padding: 0;
  margin: 0;
  height: 100%;
}

.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background: #ecf0f5;
}

/deep/.aside {
  width: 5% !important;
  height: 100%;
  background-color: #202436 !important;
  margin: 0px;
  position: fixed;
}

/deep/ .asideshow::-webkit-scrollbar,
/deep/.aside::-webkit-scrollbar {
  width: 3px;
  /*宽对应滚动条的尺寸*/
}

/*轨道*/
/deep/ .asideshow::-webkit-scrollbar-track,
/deep/.aside::-webkit-scrollbar-track {
  background: #202436;
}

/*滑块*/
/deep/ .asideshow::-webkit-scrollbar-thumb,
/deep/.aside::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #202436;
  box-shadow: 0px 1px 6px 0px rgba(3, 0, 0, 0.25);
  opacity: 0.6;
  border-radius: 2px;
}

/deep/ .asideshow {
  width: 13% !important;
  height: 100%;
  background-color: #202436;
  margin: 0px;
  position: fixed;
}

/deep/ .index-header {
  width: 87%;
  position: fixed;
  z-index: 999;
  right: 0;
}

.index-main {
  padding: 0px;
  width: 85%;
  margin-left: 14%;
  padding-top: 60px;
  height: calc(100vh - 1px);
}

.index-main::-webkit-scrollbar {
  width: 6px;
  /*宽对应滚动条的尺寸*/
}

/*轨道*/
.index-main::-webkit-scrollbar-track {
  background: #ecf0f5;
}

/*滑块*/
.index-main::-webkit-scrollbar-thumb {
  background: #666;
  box-shadow: 0px 1px 6px 0px rgba(3, 0, 0, 0.25);
  opacity: 0.6;
}

.hideMain::-webkit-scrollbar {
  width: 6px;
  /*宽对应滚动条的尺寸*/
}

/*轨道*/
.hideMain::-webkit-scrollbar-track {
  background: #ecf0f5;
}

/*滑块*/
.hideMain::-webkit-scrollbar-thumb {
  background: #666;
  box-shadow: 0px 1px 6px 0px rgba(3, 0, 0, 0.25);
  opacity: 0.6;
}

.hideMain {
  padding: 0px;
  width: 94%;
  margin-left: 5%;
  padding-top: 60px;
  height: calc(100vh - 1px);
}

.hideHeader {
  width: 95%;
  position: fixed;
  z-index: 99999;
  right: 0;
}

.asideS {
  width: 90px;
}

/* /deep/ .el-card__body{padding: 0;} */
/deep/.el-menu {
  border-right: none;
}

/deep/ .el-menu-item i,
.el-submenu__title i {
  color: #ffffff;
  font-size: 20px;
}

/deep/ .el-submenu:hover {
  background-color: #ffffff !important;
}

.head {
  width: 40px;
  height: 40px;
  border-radius: 50px;
}

.logo {
  width: 100%;
  height: 120px;
  text-align: center;
  padding-top: 20px;
}

.logoImg {
  width: 80px;
  height: 80px;
  border-radius: 50px;
  left: 3%;
}

.logoImgX {
  width: 64px !important;
  height: 64px !important;
  border-radius: 50px;
}

/deep/ .el-input__inner {
  height: 30px;
  /* border-radius: 50px; */
}

/deep/ .el-pagination__sizes .el-input .el-input__inner {
  height: 30px !important;
}
/deep/ .el-form--inline .el-form-item__content {
  vertical-align: middle;
}
/deep/ .el-form-item--mini .el-form-item__content,
.el-form-item--mini .el-form-item__label {
  line-height: 40px;
}
/deep/ .el-form-item__label {
  line-height: 40px;
}

/deep/ .el-tag--small {
  cursor: pointer;
  margin-right: 10px;
}

.input input {
  border-radius: 20%;
}

.tab {
  width: 98%;
  height: 50px;
  margin: 20px 15px 0px 5px;
}

/deep/ .el-tag {
  cursor: pointer;
  margin-top: 5px;
}

/deep/ .el-submenu .el-menu-item {
  min-width: 185px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue